// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1xKqZ","calendarButtons":"ClockData_calendarButtons__17TPX"};